// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Pg_0_2_avatarContainer__C3fyc","memberQrBar":"Pg_0_2_memberQrBar__SgQ6K"};